import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from './index';

const selectSlice = (state: RootState) => state.user || initialState;

export const selectUser = createSelector([selectSlice], state => state);
export const selectUserData = createSelector(
  [selectSlice],
  state => state.data,
);
export const selectUserIsLoading = createSelector(
  [selectSlice],
  state => state.isLoading,
);
